var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      staticClass: "mx-0",
      class: { fullSize: _vm.loading },
      attrs: { "align-center": "", "justify-center": "" },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-0 generalClass-table-padding" },
        [
          _vm.loading
            ? _c("loading-page")
            : _vm.error || !_vm.servers.length
            ? _c("default-page", {
                attrs: {
                  imageUrl: "/img/dynamic-src-images/servers.svg",
                  title: "Servers",
                  text: "It seems that you don't have any servers|Click Get Started below to add a server",
                  errorMessage: _vm.error ? _vm.errorMessage.message : "",
                  buttonText: _vm.error ? "Reload" : "Get Started",
                },
                on: { "button-clicked": _vm.buttonClicked },
              })
            : _c(
                "div",
                { ref: "scroll-check-cont" },
                [
                  _c("confirm-dialog", {
                    attrs: {
                      dialog: _vm.confirmDialog,
                      text: _vm.itemDeletionText,
                      acceptButton: "Delete",
                    },
                    on: {
                      "confirmation-event": function ($event) {
                        return _vm.deleteServer($event)
                      },
                      "mutate-confirm-dialog": _vm.mutateConfirmDialog,
                    },
                  }),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("v-data-table", {
                            staticClass: "main_page_table",
                            attrs: {
                              "mobile-breakpoint": 0,
                              height: `${
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _vm.windowSizeY - 100
                                  : _vm.windowSizeY - 96
                              }px`,
                              "items-per-page": _vm.itemsPerPage,
                              page: _vm.page,
                              "custom-sort": _vm.currentSortingAlgo,
                              "fixed-header": "",
                              dense: "",
                              "hide-default-header": "",
                              "hide-default-footer": "",
                              headers: _vm.headers,
                              "sort-by": "id",
                              items: _vm.servers,
                              "single-expand": "",
                              expanded: _vm.expanded,
                            },
                            on: {
                              "update:page": function ($event) {
                                _vm.page = $event
                              },
                              "update:expanded": function ($event) {
                                _vm.expanded = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "header",
                                fn: function ({ props: { headers } }) {
                                  return [
                                    _c("thead", [
                                      _c(
                                        "tr",
                                        _vm._l(
                                          headers.filter((el, index) => {
                                            return (
                                              index + 1 <= _vm.headersCounter
                                            )
                                          }),
                                          function (header) {
                                            return _c(
                                              "th",
                                              {
                                                key: header.value,
                                                staticClass: "allTableHeaders",
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          height: "100%",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            class:
                                                              header.value ===
                                                              "action"
                                                                ? "pl-0"
                                                                : "pl-3",
                                                            style:
                                                              header.value ===
                                                                "action" ||
                                                              _vm.headersCounter ===
                                                                1
                                                                ? "justify-content: center;"
                                                                : "",
                                                          },
                                                          [
                                                            _c("v-hover", {
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "default",
                                                                      fn: function ({
                                                                        hover,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "my-0 fullHeight",
                                                                              class:
                                                                                header.value ===
                                                                                "action"
                                                                                  ? "text-center"
                                                                                  : "allTableHeadersHover",
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.currentSortingAlgo =
                                                                                      _vm.getNewSortingAlgo(
                                                                                        header
                                                                                      )
                                                                                    _vm.selectedHeader =
                                                                                      header.value
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    header.text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  directives:
                                                                                    [
                                                                                      {
                                                                                        name: "show",
                                                                                        rawName:
                                                                                          "v-show",
                                                                                        value:
                                                                                          header.value !==
                                                                                          "action",
                                                                                        expression:
                                                                                          "header.value !== 'action'",
                                                                                      },
                                                                                    ],
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "12px",
                                                                                      "margin-left":
                                                                                        "-3px",
                                                                                    },
                                                                                  style:
                                                                                    !hover &&
                                                                                    _vm.selectedHeader !==
                                                                                      header.value
                                                                                      ? "opacity: 0.2;"
                                                                                      : "opacity: 1;",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        _vm.getSortingIcon(
                                                                                          header.currentSortAlg
                                                                                        )
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ]
                                },
                              },
                              {
                                key: "item",
                                fn: function ({ item, index }) {
                                  return [
                                    _c(
                                      "tr",
                                      {
                                        staticClass: "table_Row rowClick",
                                        attrs: {
                                          id: _vm.$vuetify.theme.dark
                                            ? "dataTableRow_dark"
                                            : "dataTableRow_light",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.expandRow(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._l(
                                          _vm.headersCounter !==
                                            _vm.headers.length
                                            ? _vm.headersCounter
                                            : _vm.headersCounter - 1,
                                          function (header, index) {
                                            return _c(
                                              "td",
                                              { key: index },
                                              [
                                                _c(
                                                  "v-row",
                                                  [
                                                    _vm.headersCounter === 1
                                                      ? _c("p", {
                                                          style: `margin-left: 30% !important;`,
                                                        })
                                                      : _vm._e(),
                                                    _vm.headers[index].value ===
                                                      "name" &&
                                                    _vm.headersCounter !==
                                                      _vm.headers.length
                                                      ? _c(
                                                          "v-icon",
                                                          {
                                                            class:
                                                              _vm.expanded.some(
                                                                (el) =>
                                                                  el.id ===
                                                                  item.id
                                                              )
                                                                ? "red--text pr-1 ml-3"
                                                                : "primary--text pr-1 ml-3",
                                                            staticStyle: {
                                                              "font-size":
                                                                "16px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.expanded.some(
                                                                    (el) =>
                                                                      el.id ===
                                                                      item.id
                                                                  )
                                                                    ? "fas fa-times-circle"
                                                                    : "fas fa-chevron-circle-down"
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass: "char-lim",
                                                        class:
                                                          _vm.headersCounter <
                                                            _vm.headers
                                                              .length &&
                                                          _vm.headers[index]
                                                            .value === "name"
                                                            ? "ml-1"
                                                            : "ml-3",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item[
                                                              _vm.headers[index]
                                                                .value
                                                            ]
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        _vm.headersCounter ===
                                        _vm.headers.length
                                          ? _c(
                                              "td",
                                              { staticClass: "text-center" },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showEditServerDialog(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "icon-edit-21x21",
                                                        staticStyle: {
                                                          "font-size": "28px",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "path1 letterSpacing0",
                                                        }),
                                                        _c("span", {
                                                          staticClass: "path2",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      id: `delete-server${index}`,
                                                      icon: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.confirmationDialog(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "icon-delete-21x21",
                                                        staticStyle: {
                                                          "font-size": "28px",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass:
                                                            "path1 letterSpacing0",
                                                        }),
                                                        _c("span", {
                                                          staticClass: "path2",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    staticClass: "mt-3 ml-1",
                                                    attrs: {
                                                      activator: `#delete-server${index}`,
                                                      bottom: "",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v("Delete"),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "expanded-item",
                                fn: function ({ item }) {
                                  return _vm._l(
                                    _vm.headers.length - _vm.headersCounter,
                                    function (headerIndex, index) {
                                      return _c(
                                        "tr",
                                        {
                                          key: index,
                                          staticClass: "expandBackground",
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass:
                                                "expandRowClass_Border mx-0",
                                              staticStyle: { height: "32px" },
                                              attrs: {
                                                justify: "space-around",
                                              },
                                            },
                                            [
                                              _vm.$vuetify.breakpoint.width <
                                              411
                                                ? _c("v-col", {
                                                    attrs: { cols: "1" },
                                                  })
                                                : _vm._e(),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: { cols: "3" },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "ml-1 my-1",
                                                      staticStyle: {
                                                        "font-weight": "600",
                                                        "font-size": "14px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.headers[
                                                            index +
                                                              _vm.headersCounter
                                                          ].text
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: { cols: "8" },
                                                },
                                                [
                                                  headerIndex <
                                                  _vm.headers.length -
                                                    _vm.headersCounter
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ml-1 my-1 pt-1 text-center char-lim",
                                                          staticStyle: {
                                                            "font-size": "14px",
                                                            margin:
                                                              "auto !important",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item[
                                                                _vm.headers[
                                                                  index +
                                                                    _vm.headersCounter
                                                                ].value
                                                              ]
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              staticClass:
                                                                "mt-3 ml-1",
                                                              attrs: {
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    height:
                                                                                      "32",
                                                                                    icon: "",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.showEditServerDialog(
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "icon-edit-21x21",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "28px",
                                                                                      color:
                                                                                        "grey !important",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path1 letterSpacing0",
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path2",
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v("Edit"),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              staticClass:
                                                                "mt-3",
                                                              attrs: {
                                                                bottom: "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function ({
                                                                        on,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "v-btn",
                                                                            _vm._g(
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    height:
                                                                                      "32",
                                                                                    icon: "",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      return _vm.confirmationDialog(
                                                                                        item
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              on
                                                                            ),
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "icon-delete-21x21",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "28px",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path1 letterSpacing0",
                                                                                    }
                                                                                  ),
                                                                                  _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "path2",
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "Delete"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.headersCounter - 1,
                                            function (header) {
                                              return _c("td", {
                                                key: header,
                                                staticStyle: { border: "none" },
                                              })
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    }
                                  )
                                },
                              },
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      "v-text",
                                      {
                                        attrs: {
                                          color: "error",
                                          icon: "warning",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "Sorry, nothing to display here :("
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c(
                            "div",
                            { staticClass: "text-center custom-table-footer" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "mx-0",
                                  attrs: {
                                    justify: "space-between",
                                    "justify-sm": "end",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ml-2 pagination-item-1" },
                                    [
                                      _vm.$vuetify.breakpoint.smAndUp
                                        ? _c("div", { staticClass: "mr-6" }, [
                                            _vm._v(" Rows per page: "),
                                          ])
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "footer-items-wrapper",
                                          class: {
                                            "mr-1":
                                              _vm.$vuetify.breakpoint.smAndUp,
                                          },
                                        },
                                        [
                                          _c("v-select", {
                                            staticClass:
                                              "footer-items-per-page mt-0",
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              "menu-props": {
                                                top: true,
                                                offsetY: true,
                                              },
                                              items: [10, 25, 50, 100],
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.paginationChangeHandler(
                                                  1
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "item",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "mb-0 char-lim-tabs page-rows-selection",
                                                      },
                                                      [
                                                        item === -1
                                                          ? _c("div", [
                                                              _vm._v("All"),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(item)
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "selection",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "page-rows-selection",
                                                      },
                                                      [
                                                        item === -1
                                                          ? _c("div", [
                                                              _vm._v(" All "),
                                                            ])
                                                          : _c("div", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(item) +
                                                                  " "
                                                              ),
                                                            ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                            model: {
                                              value: _vm.itemsPerPage,
                                              callback: function ($$v) {
                                                _vm.itemsPerPage = $$v
                                              },
                                              expression: "itemsPerPage",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("v-pagination", {
                                    staticClass: "pagination",
                                    attrs: {
                                      length: _vm.totalPages,
                                      "total-visible": _vm.$vuetify.breakpoint
                                        .xsOnly
                                        ? 5
                                        : 7,
                                      circle: "",
                                    },
                                    on: { input: _vm.paginationChangeHandler },
                                    model: {
                                      value: _vm.page,
                                      callback: function ($$v) {
                                        _vm.page = $$v
                                      },
                                      expression: "page",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm.servers.length && _vm.isAdmin === true
            ? _c(
                "v-btn",
                {
                  style: { bottom: "70px" },
                  attrs: {
                    fab: "",
                    bottom: "",
                    right: "",
                    color: _vm.$vuetify.theme.dark ? "#685AA1" : "primary",
                    dark: "",
                    fixed: "",
                  },
                  on: { click: _vm.showAddServerDialog },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              )
            : _vm._e(),
          _c(
            "v-dialog",
            {
              attrs: {
                transition: "scroll-x-transition",
                "overlay-color": "grey darken-2",
                width: _vm.$vuetify.breakpoint.smAndUp ? "550px" : "350px",
                persistent: "",
              },
              model: {
                value: _vm.dialog,
                callback: function ($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog",
              },
            },
            [
              _c(
                "v-card",
                { attrs: { color: "accent" } },
                [
                  _c(
                    "v-card-title",
                    {
                      staticStyle: {
                        "background-color": "#47BD96",
                        color: "white",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.editing ? "Edit Server" : "Add Server") +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "v-container",
                    {
                      staticClass: "pa-4 pb-0 pt-5 mt-2",
                      style: _vm.$vuetify.breakpoint.smAndUp
                        ? "width:550px"
                        : "width: 310px",
                      attrs: { "grid-list-sm": "" },
                    },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: { "lazy-validation": false },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      autofocus: true,
                                      label: "Login",
                                      rules: [
                                        _vm.rules.required,
                                        _vm.rules.integer,
                                      ],
                                      autocomplete: "username",
                                    },
                                    model: {
                                      value: _vm.server.login,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.server, "login", $$v)
                                      },
                                      expression: "server.login",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "textFieldOverride small-icon",
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      autocomplete: "new-password",
                                      counter: "",
                                      "append-icon": _vm.showPassword
                                        ? "fas fa-eye"
                                        : "fas fa-eye-slash",
                                      hint: _vm.passwordHint,
                                      "persistent-hint": _vm.editing,
                                      label: "Password",
                                      type: _vm.showPassword
                                        ? "text"
                                        : "password",
                                      rules: _vm.editing
                                        ? []
                                        : [_vm.rules.required],
                                    },
                                    on: {
                                      "click:append": function ($event) {
                                        _vm.showPassword = !_vm.showPassword
                                      },
                                    },
                                    model: {
                                      value: _vm.server.password,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.server, "password", $$v)
                                      },
                                      expression: "server.password",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "py-0", attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      label: "Server Name",
                                      rules: [
                                        _vm.rules.required,
                                        _vm.rules.maxCharName,
                                      ],
                                      counter: "",
                                      hint: "Max 50 Characters",
                                    },
                                    model: {
                                      value: _vm.server.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.server, "name", $$v)
                                      },
                                      expression: "server.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      label: "Server Address e.g. 183.78.19.1",
                                      rules: [
                                        _vm.rules.required,
                                        _vm.rules.serverAddress,
                                      ],
                                    },
                                    model: {
                                      value: _vm.server.server,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.server, "server", $$v)
                                      },
                                      expression: "server.server",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "6", sm: "2" },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      placeholder: "443",
                                    },
                                    model: {
                                      value: _vm.server.port,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.server, "port", $$v)
                                      },
                                      expression: "server.port",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "py-0",
                                  attrs: { cols: "6", sm: "4" },
                                },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      items: _vm.serverVersionOptions,
                                      "menu-props": {
                                        offsetY: true,
                                        maxHeight: "250",
                                      },
                                      label: "Select",
                                      "hide-details": "",
                                      "single-line": "",
                                    },
                                    model: {
                                      value: _vm.server.version,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.server, "version", $$v)
                                      },
                                      expression: "server.version",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "py-0", attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Description",
                                      dense: "",
                                      outlined: "",
                                      rules: [_vm.rules.maxCharDescription],
                                      counter: "",
                                      hint: "Max 200 Characters",
                                    },
                                    model: {
                                      value: _vm.server.description,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.server, "description", $$v)
                                      },
                                      expression: "server.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "pt-0" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: { click: _vm.cancelHandler },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.$refs.form.validate()
                                ? _vm.saveHandler()
                                : false
                            },
                          },
                        },
                        [_vm._v("Save")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }